import type { UserProfile } from '../../../../../_ui-core_/base/package/api/package/casino/casino-domain';
import type {
  Deactivation,
  LimitedFlag,
  UserPreferences,
} from '../../../../../_ui-core_/base/package/api/package/pam/pam-domain';
import type { TDateISO } from '../../../../../_ui-core_/base/package/date.extensions';

export const LoginStatus = {
  UNDEFINED: 'undefined',
  FETCHING: 'fetching',
  LOGGED_IN: 'loggedIn',
  LOGGED_OUT: 'loggedOut',
} as const;

export type LoginStatus = (typeof LoginStatus)[keyof typeof LoginStatus];

export type LoginObject = {
  loginStatus: LoginStatus;
  jwt?: string;
  loggedInAt?: Date;
  profile?: UserProfile;
  preferences?: UserPreferences;
  lastLogin?: Date;
  limited?: LimitedFlag[];
  newcomer?: boolean;
  deactivation?: Deactivation;
};

export type LSLoginObject = LoginObject & { loggedInAt: TDateISO };
